import { render } from "./PurchaseHistoryView.vue?vue&type=template&id=4592b7ac&scoped=true"
import script from "./PurchaseHistoryView.vue?vue&type=script&lang=js"
export * from "./PurchaseHistoryView.vue?vue&type=script&lang=js"

import "./PurchaseHistoryView.vue?vue&type=style&index=0&id=4592b7ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4592b7ac"]])

export default __exports__